export default "__VITE_PUBLIC_ASSET__07819c6b__"